import type { CountryCode } from '@module/apis/client-side/live/type';
import type { CentrifugeMessage } from '../messageTypes';
import type { FanLevel } from '../publicMessageTypes';
import type { LangCode } from './normalChatMessageTypes';

export interface SponCoinMessage {
  data: {
    type: 'SponCoin';
    message: {
      nick: string;
      id: string;
      coin: number;
      ut: string;
      lev: FanLevel;
      lang?: LangCode[];
      lcl?: CountryCode;
      rk: number;
      excelNick?: string;
      excelType?: string;
      ExcelHeartType?: any; // ?
      heart?: {
        image: string;
        json?: string;
      };
      heartMessage?: {
        message: string;
        channel: string;
        type: string;
        sex: string;
        lev: number;
        idx: number;
        id: string;
        nk: string;
        rk: number;
        lang?: LangCode[];
        lcl?: CountryCode;
      };
      reaction?: {
        name: {
          ko: string;
          ja: string;
        };
      };
    };
    created_at?: number;
  };
  seq?: undefined;
  gen?: undefined;
  offset: number;
  key?: string;
}

export const isSponCoinMessage = (item: CentrifugeMessage): item is SponCoinMessage => {
  return 'data' in item && item.data.type === 'SponCoin';
};

export interface ItemCoinMessage {
  data: {
    type: 'ItemCoin';
    message: {
      nick: string;
      id: string;
      coin: number;
      ut: string;
      lev: FanLevel;
      rk: number;
      lang?: LangCode[];
      lcl?: CountryCode;
      itemCode: string;
      excelNick?: string;
      excelType?: string;
      // 들어오긴 하나 사용 지양 권장. 잘못 들어오는 것으로 추정 중
      // heart?: {
      //   image: string;
      //   json?: string;
      // };
      heartMessage?: {
        message: string;
        channel: string;
        type: string;
        sex: string;
        lev: number;
        idx: number;
        id: string;
        nk: string;
        rk: number;
        lang?: LangCode[];
        lcl?: CountryCode;
      };
    };
    created_at?: number;
  };
  key?: string;
  offset: number;
}

export const isItemCoinMessage = (item: CentrifugeMessage): item is ItemCoinMessage => {
  return 'data' in item && item.data.type === 'ItemCoin';
};

export interface ItemCoinMessageUnparsed {
  data: {
    type: 'ItemCoin';
    message: string;
    created_at?: number;
  };
  seq?: undefined;
  gen?: undefined;
  offset: number;
}

export interface ExcelSponCoinMessage {
  data: {
    type: 'SponCoin';
    message: {
      coin: number;
      excelNick: string;
      excelType: string;
      id: string;
      lev: number;
      nick: string;
      rk: number;
      ut: string;
    };
    created_at?: number;
  };
  seq?: undefined;
  gen?: undefined;
  offset: number;
  key?: string;
}

export interface SponCoinMessageUnparsed {
  data: {
    type: 'SponCoin';
    message: string;
    created_at?: number;
  };
  seq: undefined;
  gen: undefined;
  offset: number;
}
